/*

{
  date: "01/12/2020",
  sections: [
    {
      name: "Cambios generales",
      items: [
        ``
      ]
    },
  ]
}

*/

import { LangData } from "@/lib/language";

export function getChanges(lang: LangData) {
  const changes = [
    {
      date: "05/08/2024",
      sections: [{ name: lang.generalChanges2, items: [lang.changelogAug6] }]
    },
    {
      date: "19/06/2024",
      sections: [{ name: lang.vending2, items: [lang.changelogJun8] }]
    },
    {
      date: "08/05/2024",
      sections: [{ name: lang.generalChanges2, items: [lang.changelogMay7] }]
    },
    {
      date: "22/04/2024",
      sections: [{ name: lang.generalChanges2, items: [lang.changelogAbr2] }]
    },
    {
      date: "19/03/2024",
      sections: [
        { name: lang.generalChanges2, items: [lang.changelogMar1] },
        { name: lang.vending2, items: [lang.changelogMar2] }
      ]
    },
    {
      date: "15/1/2024",
      sections: [{ name: lang.generalChanges2, items: [lang.changelogEne4] }]
    },
    {
      date: "24/11/2023",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogNov8, lang.changelogNov9]
        }
      ]
    },
    {
      date: "11/10/2023",
      sections: [
        {
          name: lang.vending2,
          items: [lang.changelogOct1]
        }
      ]
    },
    {
      date: "21/06/2023",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogJun5]
        }
      ]
    },
    {
      date: "14/06/2023",
      sections: [{ name: lang.vending2, items: [lang.changelogJun6] }]
    },
    {
      date: "05/06/2023",
      sections: [{ name: lang.generalChanges2, items: [lang.changelogJun7] }]
    },
    {
      date: "29/05/2023",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogMay1, lang.changelogMay2]
        },
        { name: lang.paymentLink2, items: [lang.changelogMay3] }
      ]
    },
    {
      date: "17/05/2023",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogMay4, lang.changelogMay5]
        },
        { name: lang.vending2, items: [lang.changelogMay6] }
      ]
    },
    {
      date: "26/04/2023",
      sections: [{ name: lang.paymentLink2, items: [lang.changelogAbr1] }]
    },
    {
      date: "28/02/2023",
      sections: [
        { name: lang.generalChanges2, items: [lang.changelogFeb9] },
        { name: lang.vending2, items: [lang.changelogFeb10] }
      ]
    },
    {
      date: "14/02/2023",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogFeb11, lang.changelogFeb12, lang.changelogFeb13]
        }
      ]
    },
    {
      date: "31/01/2023",
      sections: [{ name: lang.vending2, items: [lang.changelogEne1] }]
    },
    {
      date: "11/01/2023",
      sections: [
        { name: lang.paymentLink2, items: [lang.changelogEne2] },
        { name: lang.generalChanges2, items: [lang.changelogEne3] }
      ]
    },
    {
      date: "22/12/2022",
      sections: [
        {
          name: lang.vending2,
          items: [lang.changelogDec3, lang.changelogDec4]
        }
      ]
    },
    {
      date: "25/11/2022",
      sections: [
        { name: lang.generalChanges2, items: [lang.changelogNov1] },
        { name: lang.paymentLink2, items: [lang.changelogNov2] },
        { name: lang.vending2, items: [lang.changelogNov3] }
      ]
    },
    {
      date: "14/11/2022",
      sections: [
        { name: lang.generalChanges2, items: [lang.changelogNov4] },
        {
          name: lang.paymentLink2,
          items: [lang.changelogNov5, lang.changelogNov6, lang.changelogNov7]
        }
      ]
    },
    {
      date: "22/09/2022",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogSep1, lang.changelogSep2]
        },
        { name: lang.paymentLink2, items: [lang.changelogSep3, lang.changelogSep4] }
      ]
    },
    {
      date: "29/08/2022",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogAug2, lang.changelogAug3]
        },
        { name: lang.vending2, items: [lang.changelogAug4, lang.changelogAug5] }
      ]
    },
    {
      date: "10/08/2022",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogAug1]
        }
      ]
    },
    {
      date: "21/06/2022",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogJun4]
        },
        {
          name: lang.paymentLink2,
          items: [lang.changelogJun1, lang.changelogJun2, lang.changelogJun3]
        }
      ]
    },
    {
      date: "25/02/2022",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogFeb1, lang.changelogFeb2, lang.changelogFeb3]
        },
        {
          name: lang.paymentLink2,
          items: [lang.changelogFeb4, lang.changelogFeb5, lang.changelogFeb6, lang.changelogFeb7, lang.changelogFeb8]
        }
      ]
    },
    {
      date: "31/12/2021",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.changelogDec1, lang.changelogDec2]
        }
      ]
    },
    {
      date: "30/11/2021",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem12, lang.generalChangesItem13]
        },
        {
          name: lang.vending2,
          items: [lang.vendingItem2, lang.vendingItem3, lang.vendingItem4]
        }
      ]
    },
    {
      date: "11/11/2021",
      sections: [
        {
          name: lang.vending2,
          items: [lang.vendingItem1]
        }
      ]
    },
    {
      date: "28/10/2021",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem10, lang.generalChangesItem11]
        },
        {
          name: lang.paymentLink2,
          items: [lang.paymentLinkItem7, lang.paymentLinkItem8, lang.paymentLinkItem9]
        }
      ]
    },
    {
      date: "20/08/2021",
      sections: [
        {
          name: lang.paymentLink2,
          items: [lang.paymentLinkItem6]
        },
        {
          name: lang.users2,
          items: [lang.usersItem1]
        }
      ]
    },
    {
      date: "30/06/2021",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem9]
        },
        {
          name: lang.transactions2,
          items: [lang.transactionListItem10, lang.transactionListItem11]
        }
      ]
    },
    {
      date: "02/06/2021",
      sections: [
        {
          name: lang.generalChanges2,
          items: [
            lang.generalChangesItem5,
            lang.generalChangesItem6,
            lang.generalChangesItem7,
            lang.generalChangesItem8
          ]
        },
        {
          name: lang.usersAdmin2,
          items: [lang.usersAdminItem1]
        },
        {
          name: lang.transactionList2,
          items: [
            lang.transactionListItem4,
            lang.transactionListItem5,
            lang.transactionListItem6,
            lang.transactionListItem7,
            lang.transactionListItem8,
            lang.transactionListItem9
          ]
        }
      ]
    },
    {
      date: "01/12/2020",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem3, lang.generalChangesItem4]
        },
        {
          name: lang.paymentLink2,
          items: [
            lang.paymentLinkItem1,
            lang.paymentLinkItem2,
            lang.paymentLinkItem3,
            lang.paymentLinkItem4,
            lang.paymentLinkItem5
          ]
        }
      ]
    },
    {
      date: "23/11/2020",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem2]
        }
      ]
    },
    {
      date: "20/11/2020",
      sections: [
        {
          name: lang.generalChanges2,
          items: [lang.generalChangesItem1]
        },
        {
          name: lang.officeConfig2,
          items: [lang.officeConfigItem1, lang.officeConfigItem2]
        },
        {
          name: lang.transactionList2,
          items: [lang.transactionListItem1, lang.transactionListItem2, lang.transactionListItem3]
        },
        {
          name: lang.connectionStatus2,
          items: [lang.connectionStatusItem1, lang.connectionStatusItem2]
        }
      ]
    }
  ];
  return changes;
}
